
function getNumDiasMes(mesDias, agnoDias){
  /*
      Los meses 1,3,5,7,8,10,12 siempre tienen 31 días
      Los meses 4,6,9,11 siempre tienen 30 días
      El mes de febrero dependiendo del año puede tener 28 o 29 días
  */
  let mes = parseInt(mesDias, 10)
  let agno = parseInt(agnoDias, 10)

  if( (mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12) ) 
    return 31;
  else if( (mes === 4) || (mes === 6) || (mes === 9) || (mes === 11) ) 
    return 30;
  else if( mes === 2 )
  {
      if((agno % 4 === 0) && ((agno % 100 !== 0) || (agno % 400 === 0)))
        return 29;
      else
        return 28;
  }   
}

const HacerRX = async (numeroMov, elementoArchAju, clienteSel, lista4, lista8CC,
                createHistClienteMany, createMovClientesMany, createMovCliCCMany,
                editClienteMany, editClienteUpdDocMany, editMovClientes, editCliente, ultPF, clase, fechaHoraHoy) => {

  //ACTUALIZAR BD
  const crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
        const {data} = await operacionCRUD({
        variables: args
      });
//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        await operacionCRUD({
          variables: args
        });
      }
    }
  }

  const updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
      let codigo = 0
      if(argsCrud[0].ctrl_id === 'SI_ID'){
        codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
      }else{
        await crudBD(crudColecc[0], argsCrud[0], 0)
      }
      if(codigo!==0){
        for(let i=1; i<totDocCRUD; i++){
          argsCrud[i]._id = codigo
        }
      }
      for(let i=1; i<totDocCRUD; i++){
        await crudBD(crudColecc[i], argsCrud[i], i)
      }
    }










    let movCli = [], movCliRX = [], actServCli = []
    let valor = elementoArchAju.valor
    let saldoPendiente = clienteSel.saldoPendiente
    let saldoCl = parseInt(saldoPendiente, 10) - parseInt(valor, 10)
    let estCl = clienteSel.estadoCliente
    let ultFRX = clienteSel.fecgaUltRX

    let argsUpd = {}

    // if(hacerRX){
      //PROCESO CREAR DOCUM DE CARGUE EN MOVIMCLIENTE POR DX
      // console.log(this.props.getParametro.getParametro.comoAsigCargosAlCliente)
      // console.log(saldoCl)
      let saldoClCC = saldoCl

      // let fechaHoy = new Date()
      // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
      // let response = await this.props.fecha({
      //   variables: {}
      // });
      // const {fechaHoraHoy} = response.data.fecha
      let fechaHoy = fechaHoraHoy.substr(0, 10)
      let horaHoy = fechaHoraHoy.substr(11, 5)

      //traer el número de días del mes
      const numDM = getNumDiasMes(fechaHoy.substr(5, 2), fechaHoy.substr(0, 4))
      const numDF = numDM - parseInt(fechaHoy.substr(8, 2), 10) + 1

      let ddI = parseInt(fechaHoy.substr(8, 2), 10) - 1
      let diaFra= parseInt(fechaHoy.substr(8, 2), 10)
      let periodoFrado = ""
      // let numServ=0

      let elemento3 = []
      let difSaldoNeg = 0, valorPagNeg = 0
      //verificar si el valor total a descontar (neg) es mayor que el saldocl, si es asi, la dif se cruza con
      //los cargos positivos
      if(clienteSel.tarifa.codigoTarifa){
        elemento3 = clienteSel.tarifa
        elemento3.servicios.forEach((elemento1, i) => {
          if(elemento1.estadoServicio==="D"){
            let numDNvo = numDM - ddI
            let valorServ = Math.round((elemento1.valorServicios / numDM) * numDNvo)
            
            if(valorServ<0){
              valorPagNeg += valorServ
            }
          }
        })
        if(saldoCl<(valorPagNeg * -1)){
          difSaldoNeg = (valorPagNeg * -1) - saldoCl
        }
      }

      // console.log("Hacer RX")
      let agnoFra = fechaHoy.substr(0, 4)
      let mesFra = fechaHoy.substr(5, 2)

      elemento3 = []

      // listColecc.forEach((elemento, ii) => {
      //   if(numDX>0&&elemento.numeroOdeDX>0){
      if(clienteSel.tarifa.codigoTarifa){
        elemento3 = clienteSel.tarifa
        // console.log(elemento3.servicios.length)
        elemento3.servicios.forEach((elemento1, i) => {
          // console.log(elemento1)
          // if(elemento1.codigoServicio===elemento.codigoServicio&&elemento1.estadoServicio==="D"){
          if(elemento1.estadoServicio==="D"){
            //Si esta DX => crear movcliente => siempre carga porque al dx se le descontó
            // let listServCargoFra = []
            let numDNvo = numDM - ddI
            let valorServ = Math.round((elemento1.valorServicios / numDM) * numDNvo)
            let valorAntesI = Math.round((elemento1.valorAntesImptos / numDM) * numDNvo)

            let valorPag = 0
            if(difSaldoNeg>0&&valorServ>0){
              if(difSaldoNeg-valorServ>=0){
                valorPag = valorServ
              }else{
                valorPag = difSaldoNeg
              }
              difSaldoNeg -= valorPag
            }

            if(saldoCl<0&&valorServ>0){
              if(saldoCl+valorServ>0){
                valorPag = saldoCl * -1
              }else{
                valorPag = valorServ
              }
            }
            if(valorServ<0){
              valorPag = valorServ
            }                

            periodoFrado = fechaHoy.substr(0, 8) + (diaFra<10?'0'+diaFra:(diaFra))
            periodoFrado += ' a ' + fechaHoy.substr(0, 8) + numDM

            let numServ = elemento1.numeroServicios
            if(numServ!==0){
              let imptosServ = elemento1.imptos.map(impto => ({
                ...impto, valorImpto: Math.round(valorAntesI * impto.porcImpto / 100)}))
              if(valorServ!==0){
                // listServCargoFra.push({codigoTarifa: elemento3.codigoTarifa, descrTarifa: elemento3.descrTarifa,
                //   codigoServicio: elemento1.codigoServicio, nombreResumido: elemento1.nombreResumido, descripcionServicio: elemento1.descripcionServicio,
                //   _idSubclaseServ: elemento1.subclaseserv._id, codigoSubclaseServ: elemento1.subclaseserv.codigoSubclaseServ,
                //   descrSubclaseServ: elemento1.subclaseserv.descrSubclaseServ, _idClaseServ: elemento1.subclaseserv.claseserv._id,
                //   codigoClaseServ: elemento1.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento1.subclaseserv.claseserv.descrClaseServ,
                //   numeroServicios: numServ, valorServicios: valorServ, imptos: imptosServ,
                //   agnoFra: agnoFra, mesFra: mesFra, fechaCargo: fechaHoy, periodoFrado: periodoFrado,
                //   valorAntesImptos: valorAntesI,
                //   _id: i
                // });

                //CREA REGISTRO EN movclientes
                saldoCl += valorServ

                let movCliI = [], actCargoFra = []
                argsUpd = {}
                imptosServ.forEach((elementoI, ii) => {
                  if(elementoI.codigoImpto!==null){
                    argsUpd = {
                      "codigoImpto": elementoI.codigoImpto,
                      "descrImpto": elementoI.descrImpto,
                      "porcImpto": elementoI.porcImpto,
                      "valorImpto": elementoI.valorImpto,
                    }
                    movCliI.push(argsUpd)
                  }
                })

                //PARA CUANDO SE FACTURA UN MES ANTERIOR
                let ultMF = ""
                let tieneMCCMesAnt = true
                // let lista8CC = this.props.allMovClientesCC.allMovClientesCC

                let agno = fechaHoy.substr(0, 4)
                let mes = fechaHoy.substr(5, 2)

                // let ultPF = this.props.allProcFact1.allProcFact.filter(elemento => elemento.cicloFact===clienteSel.cicloFact)
                if(ultPF.length>0){
                  ultMF = ultPF[ultPF.length-1].mes
                }
                let difmesesUMF = ((parseInt(agno, 10) * 12) + parseInt(mes, 10)) - ((parseInt(ultMF.substr(0,4), 10) * 12) + parseInt(ultMF.substr(5,2), 10))
                //Si el la dif de meses entre hoy y el ult mes fact es > 1 => se verifica si el mes ant tiene mov
                //en movcliccs
                if(difmesesUMF>1){
                  let mesMA = parseInt(mes, 10)
                  let agnoMA = agno
                  if(mes==="01"){
                    agnoMA = (parseInt(agno, 10) - 1).toString()
                    mesMA = "12"
                  }else{
                    mesMA = (((mesMA-1)<10?'0'+(mesMA-1):(mesMA-1))).toString()
                  }
                  // console.log(agnoMA + "-" + mesMA)
                  let indexFrado = lista8CC.findIndex(servicio => (servicio.agno + "-" + servicio.mes)===(agnoMA + "-" + mesMA));
                  if(indexFrado===-1){
                    //NO tiene mov del mes anterior en movcliccs => se pasa a veros2.js para que marque un detalle en movcliccs
                    //como NO FACTURAR
                    tieneMCCMesAnt = false
                  }  
                }

                //verificar si NO tiene mov en el mes ant
                if(!tieneMCCMesAnt){
                  //verificar si esta des, sus o ret, la os lo va a pasar a act
                  if(clienteSel.estadoCliente==="DESCONECTADO"||clienteSel.estadoCliente==="SUSPENDIDO"||
                      clienteSel.estadoCliente==="RETIRADO"){
                    //crear mov en movcliccs con valor 0 y periodo NO FACTURAR para que no facture el mes
                    //esto porque cuando pasa a act, viene dx desde hace 2 meses y no se le debe fact
                    let fechaHoyMA = new Date()
                    let agnoMA = (fechaHoyMA.getFullYear()).toString()
                    let mesMA = (((fechaHoyMA.getMonth()+1)<10?'0'+(fechaHoyMA.getMonth()+1):(fechaHoyMA.getMonth()+1))).toString()
                    mesMA = parseInt(mesMA, 10)
                    if(mesMA==="01"){
                      agnoMA = (parseInt(agnoMA, 10) - 1).toString()
                      mesMA = "12"
                    }else{
                      mesMA = (((mesMA-1)<10?'0'+(mesMA-1):(mesMA-1))).toString()
                    }
                    // let periodoFradoMA = agnoMA + "-" + mesMA + "-01 a " + agnoMA + "-" + mesMA + "-30"
                    let periodoFradoMA = "NO FACTURAR"
                    // let pruebaFMA =[]
                    // pruebaFMA.push({codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,

                    argsUpd = {}
                    argsUpd = {
                      "contrato": elementoArchAju.contrato,
                      "fechaMov": fechaHoy,
                      "tipo": "C",
                      "subTipo": "RX",
                      "procesado": "N",
                      "codigoServicio": elemento1.codigoServicio,
                      "nombreResumido": elemento1.nombreResumido,
                      "descripcionServicio": elemento1.descripcionServicio,
                      "descrClaseServ": elemento1.subclaseserv.claseserv.descrClaseServ,
                      "periodo": periodoFradoMA,
                      "origen": "DX-" + clienteSel.numeroOdeDX,
                      "saldoCliente": saldoCl,
                      "valorTotal": 0,
                      "valorAntesImptos": 0,
                      "agno": agnoMA,
                      "mes": mesMA,
                      "valorPagado": 0,
                      // "valorPendiente": elemento1.valorTotal - valorPag,
                      "usuarioCreate": sessionStorage.getItem('userLogin'),
                      "imptos": []
                    };
                    actCargoFra.push(argsUpd)

                    // console.log(pruebaFMA)
                  }
                }
                //FIN PARA CUANDO SE FACTURA UN MES ANTERIOR

                argsUpd = {}
                argsUpd = {
                  "contrato": elementoArchAju.contrato,
                  "fechaMov": fechaHoy,
                  "tipo": "C",
                  "subTipo": "RX",
                  "procesado": "N",
                  "codigoServicio": elemento1.codigoServicio,
                  "nombreResumido": elemento1.nombreResumido,
                  "descripcionServicio": elemento1.descripcionServicio,
                  "descrClaseServ": elemento1.subclaseserv.claseserv.descrClaseServ,
                  "periodo": periodoFrado,
                  "origen": "DX-" + clienteSel.numeroOdeDX,
                  "saldoCliente": saldoCl,
                  "valorTotal": valorServ,
                  "valorAntesImptos": valorAntesI,
                  "agno": agnoFra,
                  "mes": mesFra,
                  "valorPagado": valorPag,
                  // "valorPendiente": elemento1.valorTotal - valorPag,
                  "usuarioCreate": sessionStorage.getItem('userLogin'),
                  "imptos": movCliI
                };
                actCargoFra.push(argsUpd)

                actCargoFra.forEach((elementoDX, ii) => {
                  // if(this.props.getParametro.getParametro.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
                    movCliRX.push(elementoDX)
                  // }else{
                  //   movCli.push(elementoDX)
                  // }

                  argsUpd = {}
                  argsUpd['tipoAct'] = "EditarServDX"
                  argsUpd['contrato'] = elementoArchAju.contrato
                  argsUpd['tarifa'] = { codigoTarifa: clienteSel.tarifa.codigoTarifa, servicios: 
                                    [{"codigoServicio": elementoDX.codigoServicio,
                                      "estadoServicio": "A"}]}
                  actServCli.push(argsUpd)
                })
              }
            }
          }
        })
      }
      
      //   }
      // })
      // //FIN PROCESO CREAR DOCUM EN MOVIMCLIENTE DE DESCUENTO (SI YA SE FACT) O CARGUE (SI NO SE HA FACT) POR DX
      // console.log(saldoCl, saldoClCC)
      // if(this.props.getParametro.getParametro.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
        saldoCl = saldoClCC
      // }

      let creaHC = []
      let argsAddHC = {
        "fechaHistCliente": fechaHoy + ' ' + horaHoy,
        "contrato": elementoArchAju.contrato,
        "movimiento": "Nota",
        "descripcion": clase,
        "detalle": `Se hace RX por Nota`,
        "relacion": numeroMov,
        "valor": elementoArchAju.valor,
        "usuarioCreate": sessionStorage.getItem('userLogin'),
      }
      creaHC.push(argsAddHC)
      //Crear el registro en histclientes
      let creaHCMany = [], creaHCMany1 = []
      creaHC.forEach((elementoHC, ii) => {
        creaHCMany.push(elementoHC)
      })
      creaHCMany1.push({histcliente: creaHCMany})

      let numDocCRUD = 0
      let totDocCRUD = 1
      let argsCrud = []
      let crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(createHistClienteMany)
      }

      argsCrud[numDocCRUD] = creaHCMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = createHistClienteMany

      // console.log(crudColecc)
      // console.log(argsCrud)
      // console.log(totDocCRUD)
      await updColecc(crudColecc, argsCrud, totDocCRUD)
      // console.log(saldoCl)
    // }

    if(movCli.length>0||movCliRX.length>0){
      let actCli = [], actCliMany = [], movCliMany = [], movCliRXMany = [], actServCliMany = []

      let numOdeDX = 0
      argsUpd = {}
      argsUpd = {
        "tipoAct": "EditarCliDX",
        "contrato": elementoArchAju.contrato,
        "numeroOdeDX": numOdeDX,
      }
      actCli.push(argsUpd)
      actCli.forEach((elementoDX, ii) => {
        actCliMany.push(elementoDX)
      })
      movCli.forEach((elementoDX, ii) => {
        movCliMany.push(elementoDX)
      })
      movCliRX.forEach((elementoDX, ii) => {
        movCliRXMany.push(elementoDX)
      })
      actServCli.forEach((elementoDX, ii) => {
        actServCliMany.push(elementoDX)
      })

      let actCliMany1 = []
      actCliMany1.push({cliente: actCliMany})
      let movCliMany1 = [], movCliRXMany1 = []
      movCliMany1.push({movcliente: movCliMany})
      if(movCliRX.length>0){
        movCliRXMany1.push({movcliente: movCliRXMany})
      }
      let actServCliMany1 = []
      actServCliMany1.push({cliente: actServCliMany})

      numDocCRUD = 0
      if(movCliRX.length>0){
        totDocCRUD = 4
      }else{
        totDocCRUD = 3
      }
      argsCrud = []
      crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(createMovClientesMany)
      }

      argsCrud[numDocCRUD] = actCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = editClienteMany

      numDocCRUD += 1

      argsCrud[numDocCRUD] = actServCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = editClienteUpdDocMany

      numDocCRUD += 1

      if(movCliRX.length>0){
        argsCrud[numDocCRUD] = movCliRXMany1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = createMovCliCCMany

        numDocCRUD += 1
      }

      argsCrud[numDocCRUD] = movCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = createMovClientesMany

      // console.log(argsCrud)
      await updColecc(crudColecc, argsCrud, totDocCRUD)

      if(clienteSel.estadoCliente!=="ACTIVO"){
        estCl = "ACTIVO"
        ultFRX = fechaHoy
      }
    }

    //ACTUALIZAR DIASMORA
    //para calcular diasmora =>
    //diasMora = movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta?movim.pagueHasta.substr(0, 10):movim.pagueHasta).getTime()) / (1000*60*60*24), 10)):0
    // let movimDX1 = await listColecc.map(movim => ({
    //   ...movim, diasMora: movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta?movim.pagueHasta.substr(0, 10):movim.pagueHasta).getTime()) / (1000*60*60*24), 10)):0}))
    let actCli = [], fechaPH = null

    if(saldoCl>0){
      let fechaMora = new Date()
      fechaMora = (fechaMora.getFullYear()) + '-' + ((fechaMora.getMonth()+1)<10?'0'+(fechaMora.getMonth()+1):(fechaMora.getMonth()+1)) + '-' + (fechaMora.getUTCDate()<10?'0'+fechaMora.getUTCDate():fechaMora.getUTCDate())
      let movimDX1 = await lista4.map(movim => ({
        ...movim, diasMora: movim.pagueHasta?Math.round(parseInt((new Date(fechaMora).getTime() - new Date(movim.pagueHasta.substr(0, 10)).getTime()) / (1000*60*60*24), 10)):0}))
      let fechaHoy1 = new Date()
      let diasHoy = fechaHoy1.getUTCDate()
      let mesHoy = fechaHoy1.getMonth()+1

      let diasMora = 0, diasMoraMayor = 0
      await movimDX1.forEach((movim, ii) => {
        diasMora = 0
        if(movim.pagueHasta&&movim.valorTotal>(movim.valorPagado+movim.valorRecibido)&&movim.valorTotal>0){
          if((movim.codigoServicio==="SISTV"||movim.codigoServicio==="SINET")&&clienteSel.cargoMensual>0){
            //Math.ceil redondea al entero por encima
              let mesesM = Math.ceil((movim.valorTotal - (movim.valorPagado+movim.valorRecibido)) / clienteSel.cargoMensual)
              if(movim.codigoServicio==="SISTV"){
                diasMora = ((mesHoy-6+mesesM) * 30) + diasHoy
              }else{
                diasMora = ((mesHoy-5+mesesM) * 30) + diasHoy - 15
              }
            // console.log(movim.contrato, movim.codigoServicio, mesesM, diasMora)
          }else{
            diasMora = movim.diasMora
          }
        }
        if(diasMora>diasMoraMayor||(diasMora<0&&diasMoraMayor===0)){
          diasMoraMayor = diasMora
        }
      })
      if(diasMoraMayor!==0){
        let fechaInicio = new Date(fechaMora).getTime();
        let fechaFin = new Date(fechaInicio-(diasMoraMayor*1000*60*60*24)+(1000*60*60*24));
        fechaPH = (fechaFin.getFullYear()) + '-' + ((fechaFin.getMonth()+1)<10?'0'+(fechaFin.getMonth()+1):(fechaFin.getMonth()+1)) + '-' + (fechaFin.getUTCDate()<10?'0'+fechaFin.getUTCDate():fechaFin.getUTCDate())
      }else{
        fechaPH = null
      }
    }else{
      fechaPH = null
    }
    argsUpd = {}
    argsUpd = {
      "tipoAct": "EditarCliPagueHasta",
      "contrato": clienteSel.contrato,
      "pagueHasta": fechaPH,
    }
    actCli.push(argsUpd)
    //FIN ACTUALIZAR DIASMORA

    let actColecc = []
    argsUpd = {
      "tipoAct": "EditarCliOdeS",
      "_id": clienteSel._id,
      "estadoCliente": estCl,
      "cargoMensual": clienteSel.cargoMensual,
      "saldoPendiente": saldoCl,
    }
    actColecc.push(argsUpd)

    let actFechas = []
    argsUpd = {
      "tipoAct": "EditarFechCli",
      "_id": clienteSel._id,
      "fechaUltOSAb": clienteSel.fechaUltOSAb,
      "fechaPrimeraActivacion": clienteSel.fechaPrimeraActivacion,
      "fechaUltDX": clienteSel.fechaUltDX,
      "fecgaUltRX": ultFRX,
      "estadoAnterior": clienteSel.estadoAnterior,
      "fechaUltOSCe": clienteSel.fechaUltOSCe,
      "fechaUltPago": clienteSel.fechaUltPago,
      "valorUltPago": clienteSel.valorUltPago,
    }
    actFechas.push(argsUpd)

    //Actualizar BD
    numDocCRUD = 0
    // totDocCRUD = movColecc.length + 2
    // totDocCRUD = movColecc.length + 3
    totDocCRUD = 3
    argsCrud = []
    crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(editMovClientes)
    }

    argsCrud[numDocCRUD] = actFechas[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = editCliente

    numDocCRUD += 1

    argsCrud[numDocCRUD] = actCli[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = editCliente

    numDocCRUD += 1

    // // console.log(movColecc)
    // movColecc.forEach((elemento1, ii) => {
    //   argsCrud[numDocCRUD] = elemento1
    //   argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    //   argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

    //   numDocCRUD += 1
    // })

    argsCrud[numDocCRUD] = actColecc[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = editCliente

    // numDocCRUD += 1

    // console.log(crudColecc)
    // console.log(argsCrud)
    // console.log(totDocCRUD)
    await updColecc(crudColecc, argsCrud, totDocCRUD)





















  const contratoFin = elementoArchAju.contrato
  // console.log(elementoArchAju.contrato)
  return contratoFin
}

export default HacerRX

// export default compose(
//   // graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {contrato: "12", orden: '_id'}}}}),

//   // graphql(queries.mutation.editOdeS, {name:'editOdeS'}),

// )(HacerRX)
